import {all, takeLatest} from 'redux-saga/effects';
import {releaseSaga, suspendSaga} from 'redux/common/saga/releaseSuspend';
import types from './types';

export function* partnersSaga() {
   yield all([
      takeLatest(types.RELEASE_PARTNER, releaseSaga),
      takeLatest(types.SUSPEND_PARTNER, suspendSaga),
   ]);
}
